import { gql } from "apollo-boost"

export const getDetails = gql`
  query Submission($id: ID!) {
    Submission:SubmissionDetails(id: $id) {
      id
      name
      type
      assignedTechnicalMonitor
      assignedFinancialMonitor
      applyingCall
      township
      region
      allies
      closureDescription
      alliedOne
      alliedTwo
      BlockingProjectDetails
      BlockingImplementationLocations
      BlockingConsultants
      BlockingDocuments
      BlockingDevelopmentObjective
      implementationPlace
      responsible
      startDate
      endDate
      strategicAxis
      preventionLevel
      scope
      issueDescription
      description
      justification
      developmentObjective
      generalObjective
      communicationObjective
      state
      status
      statusChangedAt
      deadline
      signedContractAt
      agreementNumber
      technicalOpinion
      budgeted
      approved
      evidenced
      difference
      createdAt
      implementer {
        id
        email
        councilMembers {
          charge
          name
        }
        rfc
        type
        name
        email
        phone
        vision
        history
        mission
        director
        alliances
        socialObject
        fiscalAddress
        commercialName
        previousSupports
        commercialAddress
        incomesAndExpenses
        legalRepresentative
        institutionalExperience
        proofOfCharitableContributions
        documents {
          id
          url
          name
          type
        }
      }
      specificObjectives {
        orderIndex
        description
        activities{
          id
        }
        indicators{
          id
        }
      }
      communicationObjectiveActivity
      {
        id
      }
      beneficiaries {
        name
        isBlocking
        description
        number
        gender
        educationLevel
        beneficiaryIndex
        age
        preventionLevel
        attendeeNumber
        multiRegion
        callStrategy
        ultimateEfficiencyJustification
      }
      sustainabilityDetails{
        hasResourcesOutsideFicosec
        hasIncreasedOwnIncome
        hasStrategyOfProcurement
        strategyOfProcurement
        hasInstitucionalResponsePotential
        participantsMustPayFee
      }
      documents {
        id
        url
        name
        type
      }
      closureDocuments {
        id
        url
        name
        type
      }
      schedulePlace{
        id
        place
      }
    }
  }
`

export const newgetDetailsOptimized = gql`
  query Submission($id: ID!) {
    Submission:SubmissionDetailsOptimized(id: $id) {
      id 
      name
      region 
      strategicAxis 
      preventionLevel  
      description 
      generalObjective 
      status 
      statusChangedAt 
      deadline  
      technicalOpinion 
      approved 
      createdAt
      agreementNumber
      signedContractAt
      implementer {
        id
        name
      }
      specificObjectives {
        orderIndex
        description
      }
      beneficiaries {
        name
        description
        number
        gender
        educationLevel
        beneficiaryIndex
        age
        preventionLevel
      }
      documents {
        id
        url
        name
        type
      }
    }
  }
`